module.exports = {"packages":[{"label":"Apache Toree","value":"Apache Toree"},{"label":"spylon-kernel","value":"spylon-kernel"}]}


//////////////////
// WEBPACK FOOTER
// ./src/datasets/scala.json
// module id = 62
// module chunks = 0